import appStylesHref from '../styles/index.css?url'

let stylesLoaded = false

const appendStylesheet = () => {
  if (stylesLoaded || typeof document === 'undefined') return
  stylesLoaded = true

  const existingStylesheet = document.querySelector(`link[rel="stylesheet"][href="${appStylesHref}"]`)
  if (existingStylesheet) {
    existingStylesheet.media = 'all'
    return
  }

  const preloadSelector = 'link[data-app-styles]'
  const existingPreload = document.querySelector(preloadSelector)

  if (existingPreload) {
    existingPreload.setAttribute('data-app-styles', '')
    existingPreload.href = appStylesHref
    existingPreload.as = 'style'
    existingPreload.crossOrigin = existingPreload.crossOrigin ?? ''
    if (existingPreload.rel !== 'stylesheet') {
      existingPreload.rel = 'preload'
      existingPreload.onload = () => {
        existingPreload.rel = 'stylesheet'
      }
    }
  } else {
    const preload = document.createElement('link')
    preload.rel = 'preload'
    preload.as = 'style'
    preload.href = appStylesHref
    preload.crossOrigin = ''
    preload.setAttribute('data-app-styles', '')
    preload.onload = () => {
      preload.rel = 'stylesheet'
    }
    document.head.appendChild(preload)
  }

  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = appStylesHref
  link.media = 'print'
  link.onload = () => {
    link.media = 'all'
  }
  document.head.appendChild(link)
}

export const scheduleAppStyles = () => {
  if (typeof window === 'undefined') return
  const load = () => appendStylesheet()

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(load, { timeout: 1500 })
  } else {
    window.setTimeout(load, 0)
  }
}

export const ensureAppStyles = () => {
  if (stylesLoaded) return
  appendStylesheet()
}
